import {
  collection,
  getDocs,
  query,
  orderBy,
  db
} from '../config/firebase';
import { transformDocument } from './firestoreService';
import { getPastWinnersPath } from './firestorePaths';

const FETCH_CACHE_TTL_MS = 10 * 60 * 1000;
let pastWinnersFetchCache = {
  data: null,
  timestamp: null,
};

/**
 * PastWinnersService
 * Handles operations for past winners collection
 */
class PastWinnersService {
  /**
   * Fetch all past winners, ordered by year descending
   * @returns {Promise<Array>} Array of past winner records
   */
  async fetchPastWinners() {
    if (
      pastWinnersFetchCache.data &&
      pastWinnersFetchCache.timestamp &&
      (Date.now() - pastWinnersFetchCache.timestamp) < FETCH_CACHE_TTL_MS
    ) {
      return pastWinnersFetchCache.data;
    }

    try {
      const pastWinnersRef = collection(db, getPastWinnersPath());
      const q = query(pastWinnersRef, orderBy('year', 'desc'));
      const querySnapshot = await getDocs(q);

      const pastWinners = [];
      querySnapshot.forEach((docSnapshot) => {
        const winnerData = transformDocument(docSnapshot.id, docSnapshot.data());
        pastWinners.push(winnerData);
      });

      pastWinnersFetchCache = {
        data: pastWinners,
        timestamp: Date.now(),
      };

      return pastWinners;
    } catch (error) {
      console.error('Error fetching past winners:', error);
      throw error;
    }
  }
}

// Export singleton instance
export default new PastWinnersService();
